export enum FacialRecognitionConsent {
    Allowed = 'Allowed',
    Disallowed = 'Disallowed'
}
